/* eslint-disable react/prefer-stateless-function,null,react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import OpacityPreLoader from 'components/Common/PreLoaders/OpacityPreLoader';

class RoomSendMessageForm extends Component {
  handleSubmit = async event => {
    event.preventDefault();
    if (this.props.fieldMessage.value !== '') {
      this.props.sendMessageForm();
    }
  };

  render() {
    return (
      <div className="panel-footer bg-sub">
        <div className="media">
          {this.props.messageFormRequestState.hasInProgress ? (
            <OpacityPreLoader />
          ) : null}
          <div className="media-left">
            <img
              alt=""
              className="media-object avatar avatar-sm"
              src={this.props.auntUserAvatarPath}
            />
          </div>
          <div className="media-body full-width">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label
                  htmlFor="textareaMessage"
                  className="control-label sr-only"
                >
                  {t('Сообщение')}
                </label>
                <textarea
                  maxLength="4092"
                  className="form-control"
                  rows="6"
                  id="textareaMessage"
                  placeholder={t('Напишите сообщение...')}
                  value={this.props.fieldMessage.value}
                  onChange={e => this.props.changeFieldMessage(e.target.value)}
                />
              </div>
              <div className="btn-toolbar">
                <button type="submit" className="btn btn-primary pull-right">
                  {t('Отправить')}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

RoomSendMessageForm.propTypes = {
  fieldMessage: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  changeFieldMessage: PropTypes.func.isRequired,
  sendMessageForm: PropTypes.func.isRequired,
  messageFormRequestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired
  }).isRequired,

  auntUserAvatarPath: PropTypes.string.isRequired
};

export default RoomSendMessageForm;



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomMainBlock/RoomSendMessageForm.js